import { Paper, CircularProgress, Button, Typography } from "@mui/material";
import Link from "next/link";
import { FC, useState } from "react";
import { GenericStoryElementComponentProps } from "../GeneralComponents/generic-storyline-list";
import StorylineServerProxy from "../storyline-proxy/storyline-proxy";
import { StoryElement } from "./story-element";

export interface ExportStatusProps {
    storyElement: StoryElement,
    type: "PNG" | "PDF" | "HTML"
}

export const ExportStatus:FC<ExportStatusProps> = ({ storyElement, type }) =>{
    let pathToFile = type=="PNG"?storyElement.archive?.png:type=="PDF"?storyElement.archive?.pdf:storyElement.archive?.html;
    return (
        <Typography display="inline" sx={{ border: 1, padding: 1,  width: 1 / 10 }} align="center" bgcolor={(pathToFile && (pathToFile != ""))?"#AAFFAA":"#FFAAAA"} >
            { pathToFile?<Link href={"/archive/" + pathToFile}  target="_blank">{type}</Link>:type } 
        </Typography>
    )
}



export const StoryElementArchiveDisplay:FC<GenericStoryElementComponentProps> = ({ storyElement, updateListFromServer }) => {

    let [inProgress, setInProgress] = useState(false);

    function handleArchiveElementClicked(){
        setInProgress(true);
        StorylineServerProxy.archiveStoryElement(storyElement).then(() => {
            setInProgress(false);
            updateListFromServer!();
        });
    }

    return (
        <Paper elevation={ 4 } sx= {{ padding: 1 }}>
            <ExportStatus storyElement={storyElement} type="PNG" />&nbsp;
            <ExportStatus storyElement={storyElement} type="PDF" />&nbsp;
            <ExportStatus storyElement={storyElement} type="HTML" />&nbsp;
            { inProgress?<CircularProgress/>:<Button onClick={ handleArchiveElementClicked }>Archive</Button> }&nbsp;
            <Link target="child" href={ storyElement.link }>
                { storyElement.title }
            </Link>
        </Paper>
    )
}
